import React from 'react';

const PersonalInformationSection = ({ 
  formData, 
  handleChange, 
  emailError, 
  isSubmitting 
}) => {
  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-800 font-poppins mb-4 border-b-2 border-gray-200 pb-2">
        Personal Information
      </h3>

      <div className="space-y-4">
        <div className="relative">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
            Name *
          </label>
          <input
            type="text"
            id="name"
            name="name"
            required
            value={formData.name}
            onChange={handleChange}
            disabled={isSubmitting}
            className="w-full px-3 py-2.5 border border-gray-300 rounded-lg font-poppins transition-all duration-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
            placeholder="Enter your full name"
          />
        </div>

        <div className="relative">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
            Email *
          </label>
          <input
            type="email"
            id="email"
            name="email"
            required
            value={formData.email}
            onChange={handleChange}
            disabled={isSubmitting}
            className={`w-full px-3 py-2.5 border rounded-lg font-poppins transition-all duration-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm ${
              emailError ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder="Enter your email address"
          />
          {emailError && (
            <p className="mt-1 text-sm text-red-600 font-poppins">{emailError}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PersonalInformationSection;